/**
 * description: 质保金
 * dateTime: 2024/3/20-14:02
 * author:
 */
import request, {METHODS} from "@/api";
import UrlConfig from "@/api/UrlConfigs.ts";
import API from "@/services/typings";


export const qualityMoneyAccountPage = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyAccountPage, {
    ...options,
    method: METHODS.POST,
})

/**
 *质保金账户-根据id查询详情
 * @param id
 * @param options
 */
export const qualityMoneyAccountById = (id: string, options?: API.Options) => request(`${UrlConfig.plusPmWeb.QualityMoneyAccountById}?id=${id}`, {
    ...options,
    method: METHODS.POST,
})

/**
 * 质保金账户-明细分页查询
 * @param options
 */
export const qualityMoneyAccountDetailPage = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyAccountDetailPage, {
    ...options,
    method: METHODS.POST,
})

/**
 * 质保金账户-质保金配置-分页查询
 * @param options
 */
export const qualityMoneyConfigPage = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyConfigPage, {
    ...options,
    method: METHODS.POST,
})
/**
 * 质保金账户-质保金配置-保存
 * @param options
 */
export const qualityMoneyConfigSave = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyConfigSave, {
    ...options,
    method: METHODS.POST,
})
/**
 * 质保金账户-质保金配置-根据Id删除数据
 * @param id
 * @param options
 */
export const qualityMoneyConfigDelete = (id: string, options?: API.Options) => request( `${UrlConfig.plusPmWeb.QualityMoneyConfigDelete}?id=${id}`, {
    ...options,
    method: METHODS.POST,
})
/**
 * 质保金账户-质保金配置-通过Id查询单一结果
 * @param id
 * @param options
 */
export const qualityMoneyConfigById = (id: string, options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyConfigSelectAllById + id, {
    ...options,
    method: METHODS.GET,
})
/**
 * 质保金-质保金明细-新增质保金明细
 * @param options
 */
export const qualityMoneyAccountAddAccountDetail = (options?: API.Options) => request(UrlConfig.plusPmWeb.AddAccountDetail, {
    ...options,
    method: METHODS.POST,
})

/**
 * 导出明细
 * @param options
 */
export const qualityMoneyAccountExportDetail = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyAccountExportDetail, {
    ...options,
    method: METHODS.GET,
})

/**
 * 导出质保金账户信息
 * @param options
 */
export const qualityMoneyAccountExportQualityMoney = (options?: API.Options) => request(UrlConfig.plusPmWeb.QualityMoneyAccountExportQualityMoney, {
    ...options,
    method: METHODS.GET,
})

/**
 * 导出质保金流水
 * @param options
 */
export const exportAccountDetail = (options?: API.Options) => request(UrlConfig.plusPmWeb.ExportAccountDetail, {
    ...options,
    method: METHODS.GET,
})
/**
 * 退质保金
 * @param options
 */
export const realRetreatQualityMoney = (options?: API.Options) => request(UrlConfig.plusPmWeb.RealRetreatQualityMoney, {
    ...options,
    method: METHODS.POST,
})
/**
 * 质保金-质保金配置-根据ID查询配置
 * @param options
 */
export const findConfigById = (id: string, options?: API.Options) => request(`${UrlConfig.plusPmWeb.FindConfigById}?id=${id}`, {
    ...options,
    method: METHODS.POST,
})
/**
 * 质保金账户-质保金配置-保存
 * @param options
 */
export const saveConfig = (options?: API.Options) => request(UrlConfig.plusPmWeb.SaveConfig, {
    ...options,
    method: METHODS.POST,
})
/**
 * 工人管理-质保金-补充账户查询
 * @param options
 */
export const findProjectExternalEmployeeList = (options?: API.Options) => request(UrlConfig.plusPmWeb.FindProjectExternalEmployeeList, {
    ...options,
    method: METHODS.POST,
})

